<template>

    <li class="uk-margin-remove uk-padding-remove">
        <div class="uk-card-body">
            <div class="uk-grid-small"
                 uk-grid>

                <!-- Product -->
                <div class="uk-width-1-3@m uk-width-1-1@s">
                    <div class="uk-card uk-grid-small"
                         uk-grid>

                        <div v-if="ShopItem.image" class="uk-width-1-3 uk-width-1-4@s uk-width-max-xsmall">
                            <div class="uk-height-1-1">
                                <a id="tm-main-images" class="tm-image-link tm-image-link-border" :href="ShopItem.href">
                                    <img class="uk-height-max-xsmall" :src="ShopItem.image.src">
                                </a>
                            </div>
                        </div>

                        <div v-else class="uk-width-1-3 uk-width-1-4@s uk-width-max-xsmall">
                            <a :href="ShopItem.href">
                                <div id="tm-main-images" class="tm-no-image-link-border uk-position-relative">
                                    <canvas width="200" height="200"></canvas>
                                    <div class="tm-no-image tm-no-image-cart uk-flex uk-flex-column uk-flex-center uk-flex-middle">
                                        <span class="uk-icon" uk-icon="icon: image;ratio: 2;"></span>
                                        <span>No image</span>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="uk-width-expand">
                            <div class="uk-text-meta uk-text-xsmall">{{ ShopGroup.name }}</div>
                            <a class="uk-h4" :href="ShopItem.href">{{ ShopItem.name }}</a>
                        </div>

                    </div>
                </div>

                <!-- Quantity, Prices, Sum -->
                <div class="uk-width-expand">
                    <div class="uk-grid-small tm-cart-item-info"
                         uk-grid>

                        <!-- Quantity -->
                        <div class="uk-width-1-1 uk-width-1-3@s uk-text-center tm-cart-item-quantity">
                            <div class="uk-text-meta uk-hidden@m uk-margin-xsmall-bottom">Количество</div>
                            <div class="uk-flex uk-flex-inline">
                                <input @change="$emit('update-shop-item-quantity',OrderItem.quantity,ShopItem)"
                                   v-model="OrderItem.quantity"
                                   class="uk-input tm-cart-input-width uk-text-center">
                            </div>
                        </div>

                        <!-- Prices -->
                        <div class="uk-width-1-1 uk-width-1-3@s tm-cart-item-prices">

                            <div class="uk-text-meta uk-hidden@m uk-margin-xsmall-bottom uk-text-center">Цена</div>

                            <div class="uk-card uk-card-small tm-prices">

                                <div v-for="ShopItemPrice in ShopItemPrices">

                                    <span v-if="ShopItemPrice.ShopItemPrice.parent_id === 0"
                                          class="tm-item-card-price uk-margin-small-right">
                                        {{ ShopItemPrice.ShopItemPrice.calculated_price.toFixed(2) }}&nbsp;{{ ShopItemPrice.ShopCurrency.name }}
                                        <span v-if="ShopItemPrice.ShopItemPriceType.description"
                                              :title="ShopItemPrice.ShopItemPriceType.description"
                                              uk-icon="icon: question"
                                              class="uk-icon"
                                              uk-tooltip
                                              style="cursor: help;position: absolute;right: -15px;top: -3px;margin: 0 !important;"></span>
                                    </span>

                                                        <span v-else
                                                              class="tm-item-card-price-wholesale uk-text-baseline">
                                        {{ ShopItemPrice.ShopItemPrice.calculated_price.toFixed(2) }}&nbsp;{{ ShopItemPrice.ShopCurrency.name }}
                                        <span v-if="ShopItemPrice.ShopItemPriceType.description"
                                              :title="ShopItemPrice.ShopItemPriceType.description"
                                              uk-icon="icon: question"
                                              class="uk-icon"
                                              uk-tooltip
                                              style="cursor: help;position: absolute;right: -17px;top: -7px;margin: 0 !important;"></span>
                                    </span>

                                </div>

                            </div>

                        </div>

                        <!-- Sum -->
                        <div class="uk-width-1-1 uk-width-1-3@s uk-text-center tm-cart-item-sum">
                            <div class="uk-text-meta uk-hidden@m">Сумма</div>
                            <span class="uk-text-lead" v-if="OrderItem.amount === 0">По запросу</span>
                            <span class="uk-text-lead" v-else>{{ OrderItem.amount }} {{ selectedProductPrice.ShopCurrency.name }}</span>
                        </div>

                    </div>
                </div>

                <!-- Actions -->
                <div class="uk-width-auto@m uk-width-1-1@s uk-text-center uk-text-right@m tm-cart-item-remove">
                    <a @click="$emit('remove-from-cart')" class="uk-text-danger uk-visible@m" title="Удалить" uk-tooltip="offset: 13;">
                        <span uk-icon="icon: close" class="uk-icon-button uk-icon uk-text-danger"></span>
                    </a>
                    <a @click="$emit('remove-from-cart')" class="uk-button uk-button-danger uk-hidden@m"><span uk-icon="icon: trash" class="uk-icon uk-hidden@m tm-cart-item-trash-icon"></span><span class="uk-hidden@m" style="margin-left: 5px;">Удалить</span></a>
                </div>

            </div>
        </div>
    </li>
</template>
<script>


    export default {

        props: {
            ShopItem: {
                type: Object
            },
            ShopGroup: {
                type: Object
            },
            Asset: {
                type: Object
            },
            ShopOrderItem: {
                type: Object
            },
            ShopItemPrices: {
                type: Array
            }
        },
        data() {
            return {
                selectedProductPrice: {},
                OrderItem: this.ShopOrderItem,
                loading: true
            }
        },
        watch: {
            'OrderItem.quantity': {
                immediate: true,
                handler(newVal, oldVal) {
                    this.ShopItemPrices.map((ProductPrice) => {
                        if (this.OrderItem.quantity >= ProductPrice.ShopItemPrice.price_break) {
                            this.selectedProductPrice = ProductPrice;
                        }
                    });
                }
            },
            ShopOrderItem() {
                this.OrderItem.amount = this.ShopOrderItem.amount;
            }
        },
        created() {
        },
        methods: {
            plus() {
                this.OrderItem.quantity = parseInt(this.OrderItem.quantity) + 1;
                this.$emit('update-shop-item-quantity',this.OrderItem.quantity,this.ShopItem)
            },
            minus() {
                if(parseInt(this.OrderItem.quantity) > 1){
                    this.OrderItem.quantity = parseInt(this.OrderItem.quantity) - 1;
                    this.$emit('update-shop-item-quantity',this.OrderItem.quantity,this.ShopItem)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// CartShopItem.vue?19b94931